/**
 * Contact page - Exam Portal
 */

import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="page page-default" data-testid="contact-page">
      <header className="page-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Reach out with questions, feedback, or support needs.</p>
      </header>

      <section className="page-section grid-2">
        <div>
          <h2>Get in Touch</h2>
          <p>Email: support@zizacademy.example</p>
          <p>Phone: +1 (555) 123-4567</p>
          <p>Hours: Mon–Fri, 9:00–17:00</p>
        </div>
        <div>
          <h2>Send a Message</h2>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label className="form-label" htmlFor="contact-name">Your Name</label>
              <input id="contact-name" type="text" className="form-input" placeholder="Enter your name" required />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="contact-email">Email</label>
              <input id="contact-email" type="email" className="form-input" placeholder="Enter your email" required />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="contact-message">Message</label>
              <textarea id="contact-message" className="form-textarea" placeholder="How can we help?" rows={4} />
            </div>
            <button className="btn btn-primary" type="submit">Send</button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
